import React, { Dispatch, SetStateAction, useState } from "react";
import ModalContainer from "./ModalContainer";
import Circlebtn from "./Circlebtn";
import { SmallCrossIcon } from "../assets/icons/Icons";
import { cn } from "../utils/cn";

interface MainModalProps {
  children: React.ReactNode;
  label?: string;
  subLabel?: string;
  width?: string;
  className?: string;
  header?: boolean;
  btnStyle?: "normal" | "circle";
  setShowModal?: Dispatch<SetStateAction<boolean>>;
  setShowOption?: Dispatch<SetStateAction<string>>;
}

const MainModal: React.FC<MainModalProps> = ({ children, label, subLabel, width, className, header = false, btnStyle = "circle", setShowModal, setShowOption }) => {
  const [isClosing, setIsClosing] = useState<boolean>(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setShowModal && setShowModal(false);
      setShowOption && setShowOption("");
    }, 250);
  };
  return (
    <div onClick={handleClose} className="fixed inset-0 flex items-center justify-center z-50 w-full h-full bg-[#0f0e11ab]">
      <ModalContainer
        width={width || "406px"}
        // minHeight="358px"
        maxHeight="630px"
        className={cn(`py-4 px-5 shadow-xl transition-transform duration-300 top-[80px] bg-[#EAE9EF] ${isClosing ? 'animate-zoomOut' : 'animate-zoomIn'}`, className)}
      >
        {
          !header &&
          <div className="mb-1">
            {
              !subLabel ?
                <h1 className="text-[#0F0C18] text-[24px] font-semibold tracking-tight mt-1">{label || "Demo Text"}</h1> :
                <h1 className="text-[#9392A2] text-sm font-semibold tracking-tight mt-1">{subLabel || "Demo Text"}</h1>
            }
          </div>
        }
        {
          btnStyle === "circle" ?
          <div onClick={handleClose}>
            <Circlebtn icon={<SmallCrossIcon />} className="bg-white w-8 h-8 absolute right-4 top-4" />
          </div>
              :
          <div onClick={handleClose} className="absolute right-4 top-[20px] cursor-pointer">
            <svg  width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 0.98877L0.999999 10.9888" stroke="#0F0C18" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M11 10.9888L1 0.988786" stroke="#0F0C18" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </div>
        }
        {children}
      </ModalContainer>
    </div>
  );
};

export default MainModal;